import React from "react";
import * as FilterPopupStyles from "../configuration-header/styles/FilterPopupStyle";
import * as Styles from "./styles/FilterPopupHeaderStyle";
import FilterArrowButton from "../../common/FilterArrowButton";
import { type ModelFilterLabelType, useModelFilterLabel } from "../../../../utils/labels";
import { useModelFilterSelector } from "../../../../redux/store";
import useFilterLabels from "../../../../hooks/useFilterLabels";
import Icon, { IconArrowRightLong } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import type { ModelFilterId } from "../../../../utils/constants/filterConstants";

type FilterPopupHeader = {
    onClose: () => void;
    filterId?: ModelFilterId;
};

const FilterPopupHeader = (props: FilterPopupHeader): JSX.Element => {
    const { onClose, filterId } = props;

    let removeFilter;
    let filterCount = 0;
    if (filterId) {
        // While this is conceptually against hooks, we 100% know that this component will either always have a filterId, or never.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ({ removeFilter, filterCount } = useFilterLabels(filterId));
    }

    const resultCount = useModelFilterSelector((state) => state.modelResults.totalResultCount);
    let seeResultsLabelKey: ModelFilterLabelType = "seeResults";
    if (resultCount === 1) seeResultsLabelKey = "seeResult";
    if (resultCount === 0) seeResultsLabelKey = "noResults";

    const seeResultsLabel = useModelFilterLabel(seeResultsLabelKey, { value: resultCount });
    const backLabel = useModelFilterLabel("back");
    const clearFilterLabel = useModelFilterLabel(filterCount === 1 ? "clearFilter" : "clearFilters");

    // Split the clear filter label so we can apply styling.
    const clearFilterLabelSplit = clearFilterLabel.split("{value}");

    return (
        <Styles.Header>
            {filterCount === 0 && <FilterArrowButton text={backLabel} onClick={onClose} arrowDirection="left" />}

            {filterId && removeFilter && filterCount > 0 && (
                <Styles.Button type="button" onClick={removeFilter} hasWhiteBackground hasIconLeft>
                    <IconWrapper>
                        <Icon variant="close" />
                    </IconWrapper>
                    <Styles.Text>
                        {clearFilterLabelSplit[0]}
                        <FilterPopupStyles.ResultCount>{filterCount}</FilterPopupStyles.ResultCount>
                        {clearFilterLabelSplit[1]}
                    </Styles.Text>
                </Styles.Button>
            )}
            <Styles.Button isPrimary disabled={resultCount === 0} onClick={onClose}>
                <Styles.Text>{seeResultsLabel}</Styles.Text>
                <IconWrapper>
                    <IconArrowRightLong />
                </IconWrapper>
            </Styles.Button>
        </Styles.Header>
    );
};

export default FilterPopupHeader;
